module.exports = __webpack_public_path__ + "static/media/rating.f5b016c5.png";